var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#506293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d4c76"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_11536",
    x: 5.902,
    y: 5.402,
    width: 14.464,
    height: 20.195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2994ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f57ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_11537",
    x: 15.217,
    y: 8.984,
    width: 10.882,
    height: 10.166,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0080ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030fa"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_59475",
    x: 3.902,
    y: 3.902,
    width: 14.464,
    height: 20.195,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc31f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_59476",
    x: 13.217,
    y: 7.484,
    width: 10.882,
    height: 10.166,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48240",
    "data-name": "Group 48240",
    transform: "translate(14602 15709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48207",
    "data-name": "Group 48207"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25788",
    "data-name": "Rectangle 25788",
    width: 30,
    height: 30,
    transform: "translate(-14602 -15709)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-14595.598 -15702.598)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6.4, -6.4)",
    filter: "url(#Path_11536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11536-2",
    "data-name": "Path 11536",
    d: "M10.747,9.318a.716.716,0,0,0-.716.716V12.9a.717.717,0,0,1-.717.716H7.165V2.87a1.444,1.444,0,0,0-.976-1.362l-.212-.071H9.314a.717.717,0,0,1,.717.717V4.3a.716.716,0,1,0,1.433,0V2.153A2.152,2.152,0,0,0,9.314,0h-7.7A.563.563,0,0,0,1.535.02C1.5.017,1.468,0,1.433,0A1.434,1.434,0,0,0,0,1.437v12.9A1.444,1.444,0,0,0,.976,15.7l4.312,1.437a1.483,1.483,0,0,0,.444.067,1.434,1.434,0,0,0,1.433-1.433V15.05H9.314A2.152,2.152,0,0,0,11.464,12.9V10.035a.716.716,0,0,0-.716-.716Zm0,0",
    transform: "translate(6.4 6.4)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6.4, -6.4)",
    filter: "url(#Path_11537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11537-2",
    "data-name": "Path 11537",
    d: "M285,109.742l-2.866-2.866a.716.716,0,0,0-1.223.507v2.149h-2.866a.716.716,0,1,0,0,1.433h2.866v2.149a.716.716,0,0,0,1.223.507L285,110.755A.716.716,0,0,0,285,109.742Zm0,0",
    transform: "translate(-261.62 -96.68)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6.4, -6.4)",
    filter: "url(#Path_59475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59475-2",
    "data-name": "Path 59475",
    d: "M10.747,9.318a.716.716,0,0,0-.716.716V12.9a.717.717,0,0,1-.717.716H7.165V2.87a1.444,1.444,0,0,0-.976-1.362l-.212-.071H9.314a.717.717,0,0,1,.717.717V4.3a.716.716,0,1,0,1.433,0V2.153A2.152,2.152,0,0,0,9.314,0h-7.7A.563.563,0,0,0,1.535.02C1.5.017,1.468,0,1.433,0A1.434,1.434,0,0,0,0,1.437v12.9A1.444,1.444,0,0,0,.976,15.7l4.312,1.437a1.483,1.483,0,0,0,.444.067,1.434,1.434,0,0,0,1.433-1.433V15.05H9.314A2.152,2.152,0,0,0,11.464,12.9V10.035a.716.716,0,0,0-.716-.716Zm0,0",
    transform: "translate(6.4 6.4)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6.4, -6.4)",
    filter: "url(#Path_59476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59476-2",
    "data-name": "Path 59476",
    d: "M285,109.742l-2.866-2.866a.716.716,0,0,0-1.223.507v2.149h-2.866a.716.716,0,1,0,0,1.433h2.866v2.149a.716.716,0,0,0,1.223.507L285,110.755A.716.716,0,0,0,285,109.742Zm0,0",
    transform: "translate(-261.62 -96.68)",
    fill: "url(#linear-gradient-4)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5c14b193.svg";
export { ForwardRef as ReactComponent };